import { create } from "zustand";
import useLoadingStore from "./use-loading";
import { makeRequest } from "api/api-client";
import { HTTP } from "constants/http-method";
import { API_ENDPOINTS } from "api/endpoints";

const useOrganizationStore = create((set) => ({
  organization: null,

  // Function to fetch organization details
  fetchOrganization: async ({ successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.VIEW_ORGANIZATION_DETAILS
      );

      if (response.success) {
        set({ organization: response.data });
        successCallback && successCallback(response.data);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to add organization
  addOrganization: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.ADD_ORGANIZATION_DETAILS,
        data
      );

      if (response.success) {
        set({ organization: response.data });
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update organization details
  updateOrganization: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_ORGANIZATION_DETAILS,
        data,
        null,
        data?.id
      );

      if (response.success) {
        set({ organization: response.data });
        successCallback && successCallback(response);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useOrganizationStore;
